import { useEffect, useRef, useState, type ReactNode } from "react";

// 页面滚动渐显包装组件
export function Reveal({
  children,
  className = "",
  delay = 0,
}: {
  children: ReactNode;
  className?: string;
  delay?: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

// 分区通用标题
export function SectionHead({
  index,
  en,
  title,
  desc,
  align = "left",
  extra,
}: {
  index: string;
  en: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  extra?: ReactNode;
}) {
  return (
    <div
      className={`mb-8 md:mb-10 flex flex-col gap-5 sm:flex-row sm:items-end ${
        align === "center" ? "sm:flex-col sm:items-center sm:text-center" : "sm:justify-between"
      }`}
    >
      <div className={align === "center" ? "flex flex-col items-center" : ""}>
        <div className="mb-3 flex items-center gap-2">
          <span className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
            {en}
          </span>
          <span className="h-px w-8 bg-primary-300" />
          <span className="font-label text-xs text-secondary-500">{index}</span>
        </div>
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px]">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600 md:text-[15px]">{desc}</p>
        )}
      </div>
      {extra}
    </div>
  );
}